// pull in config vars
import * as config from "../config"
import fetch from "isomorphic-fetch"

export default async function jamIsPublic(JAM_ID: string): Promise<boolean> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/is_public`,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			},
		)

		const json = await res.json()

		return json.public
	} catch (e) {
		return false
	}
}
